import { createFileRoute } from '@tanstack/react-router'
import { DossiersPage } from 'pages/claims/DossiersPage'
import { dossiersSearchParams } from 'routes/dossiers/-searchParams'

const RouteComponent = () => {
  const {
    siteId,
    dossierId,
    assetId,
    assetType,
    sentinelId,
    templateId,
    subjectId,
    dossierSearch,
    view,
  } = Route.useSearch()
  return (
    <DossiersPage
      siteId={siteId ?? null}
      dossierId={dossierId}
      assetId={assetId}
      assetType={assetType}
      sentinelId={sentinelId}
      templateId={templateId}
      subjectId={subjectId}
      dossierSearch={dossierSearch}
      view={view}
    />
  )
}

export const Route = createFileRoute('/dossiers/')({
  component: RouteComponent,
  validateSearch: dossiersSearchParams,
  staticData: {
    title: 'Dossiers',
    layout: {
      enableScrolling: false,
    },
  },
})
